module.exports = __webpack_public_path__ + "img/tweet.a648f5e.svg";